import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import iconImage from "../icon.png";
import ptFlag from "../assets/flags/pt.png";
import enFlag from "../assets/flags/en.png";
import deFlag from "../assets/flags/de.png";
import "../App.css"; // or NavBar.css

function NavBar() {
    const { lang, setLang, t } = useLanguage();
    const [open, setOpen] = useState(false);
  
    const flagMap = {
      pt: ptFlag,
      en: enFlag,
      de: deFlag
    };
  
    return (
      <div className="nav-left">
        <NavLink to="/" className="nav-icon">
          <img src={iconImage} alt="App Icon" className="nav-icon" />
        </NavLink>
  
        <div style={{ display: "flex", alignItems: "center"}}>
          <NavLink to="/data" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            {t("nav.data")}
          </NavLink>
          <NavLink to="/model" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            {t("nav.model")}
          </NavLink>
          <NavLink to="/calendar" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
            {t("nav.calendar")}
          </NavLink>
  
            <div className="lang-selector-dropdown" onClick={() => setOpen(!open)}>
            <img src={flagMap[lang]} alt={lang} className="flag-icon" />
            {open && (
                <div className="dropdown-menu">
                <div onClick={() => { setLang("pt"); setOpen(false); }}>
                    <img src={ptFlag} alt="PT" className="flag-icon" /> Português
                </div>
                <div onClick={() => { setLang("en"); setOpen(false); }}>
                    <img src={enFlag} alt="EN" className="flag-icon" /> English
                </div>
                <div onClick={() => { setLang("de"); setOpen(false); }}>
                    <img src={deFlag} alt="DE" className="flag-icon" /> Deutsch
                </div>
                </div>
            )}
            </div>
        </div>
      </div>
    );
  }

export default NavBar;
